import { inject, Injectable } from "@angular/core";
import { Params, Router } from "@angular/router";

import { GlobalConstants } from "@venecia/constants";

@Injectable({ providedIn: 'root' })
export class RouterService {
    private readonly router = inject(Router);

    public setQueryParams(queryParams: Params): void {
        this.router.navigate([], {
            queryParams,
            queryParamsHandling: 'merge',
            replaceUrl: false
        });
    }
}